import yaml from 'yaml'
import {merge} from 'merge-json'
import formatYAML, {DefaultOptions} from '../../CodeFormatters/YAMLFormatter/formatYAML'


export default async function mergeYAML(input1, input2, options) {
  const object1 = yaml.parse(input1 || '{}')
  const object2 = yaml.parse(input2 || '{}')

  const result = merge(object1, object2)
  return formatYAML(yaml.stringify(result), {...DefaultOptions, ...options})
}